import { actions } from "../../utils/constants"

export const selectEmployee = (user) => {
    return { type: actions.SELECT_USER, user }
}
export const changeDate = (date) => {
    return { type: actions.CHANGE_DATE, date }
}